const BACKEND_URL = (window as any)?._env_?.REACT_APP_BACKEND_URL;
const SAVE_AND_RETRIEVE_URL = (window as any)?._env_
  ?.REACT_APP_SAVE_AND_RETRIEVE_URL;

export const API = {
  V3: {
    PROJECT: {
      ACTIVE_CONFIG: (projectname: string) =>
        `${BACKEND_URL}/v3/formbuilder/project/${projectname}/active`,
      CONFIG_BY_VERSION: (projectname: string, version: string) =>
        `${BACKEND_URL}/v3/formbuilder/project/${projectname}/version/${version}`,
    },
    FORM_DATA: {
      FORM_DATA: (configVersion: string, project: string) =>
        `${BACKEND_URL}/v3/formbuilder/formData?configVersion=${configVersion}&project=${project}`,
    },
    STATIC_RESOURCES: {
      STATIC_RESOURCE: (identifier: string) =>
        `${BACKEND_URL}/v3/formbuilder/staticResources/${identifier}`,
    },
    FONT_RESOURCES: {
      FONT_RESOURCE: (identifier: string) =>
        `${BACKEND_URL}/v3/formbuilder/fontResources/${identifier}`,
    },
    TRANSLATION_RESOURCES: {
      ACTIVE_CONFIG: (project: string, translationName: string) =>
        `${BACKEND_URL}/v3/formbuilder/translations/project/${project}/translation/${translationName}/active`,
      SPECIFIC_CONFIG: (
        project: string,
        translationName: string,
        configVersion: string
      ) =>
        `${BACKEND_URL}/v3/formbuilder/translations/project/${project}/translation/${translationName}/version/${configVersion}`,
      ALL_FROM_CONFIG: (project: string, configVersion: string) =>
        `${BACKEND_URL}/v3/formbuilder/translations/project/${project}/version/${configVersion}`,
    },
    SAVE_AND_RETRIEVE: {
      CREATE_SAR: (projectname: string) =>
        `${SAVE_AND_RETRIEVE_URL}/v1/saveAndRetrieve/${projectname}`,
      GET_USER_DATA: (projectname: string, sarCode: string) =>
        `${SAVE_AND_RETRIEVE_URL}/v1/saveAndRetrieve/${projectname}?sarcode=${sarCode}`,
      UNSUBSCRIBE_SAR: (projectname: string, sarCode: string) =>
        `${SAVE_AND_RETRIEVE_URL}/v1/saveAndRetrieve/${projectname}?sarcode=${sarCode}`,
      SEND_2FA_SAR: (projectname: string) =>
        `${SAVE_AND_RETRIEVE_URL}/v1/saveAndRetrieve/${projectname}/2fa/send`,
      VERIFY_2FA_SAR: (projectname: string) =>
        `${SAVE_AND_RETRIEVE_URL}/v1/saveAndRetrieve/${projectname}/2fa/verify`,
    },
    UPLOADS: {
      CREATE: (version: string, project: string, field: string) =>
        `${BACKEND_URL}/v3/formbuilder/uploads?configVersion=${encodeURIComponent(
          version
        )}&project=${encodeURIComponent(
          project
        )}&fieldName=${encodeURIComponent(field)}`,
      DELETE: (id: string) =>
        `${BACKEND_URL}/v3/formbuilder/uploads/${encodeURIComponent(id)}`,
    },
    SALARY_UPLOAD: {
      CHECK_SALARY: `${BACKEND_URL}/v3/formbuilder/salaryUpload`,
    },
    SESSION: {
      CREATE: `${BACKEND_URL}/v3/formbuilder/session`,
      VALIDATE: (sessionId: string) =>
        `${BACKEND_URL}/v3/formbuilder/session/${sessionId}/validate`,
      GET: (sessionId: string) =>
        `${BACKEND_URL}/v3/formbuilder/session/${sessionId}`,
      UPDATE: `${BACKEND_URL}/v3/formbuilder/session`,
    },
  },
};
